import classNames from "classnames";
import { DComponent } from "../DComponent";
import SectionLoading from "../SectionLoading";

export default class DIframe extends DComponent {
  constructor({
    parent,
    id,
    isDialog,
    title,
    description,
    source = "",
    onClose = () => { },
    sectionLoading,
    key,
    hideClose
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("DIframe"),
      classClose: hideClose ? "hide" : "",
      source: source,
    }, true);
    this.isDialog = isDialog;
    this.title = title;
    this.description = description;
    this.source = source;
    this.onClose = onClose;
    this.sectionLoading = sectionLoading;
    this.key = key;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "DIframe");
  }

  loadHtml() {
    if (this.isDialog) {
      return require("html-loader!./iframe-dialog.html");
    } else {
      return require("html-loader!./index.html");
    }
  }

  after() {
    if (!this.source) {
      this.sectionLoading = new SectionLoading({ parent: $("iframe", this.element).parent() });
      this.sectionLoading.show();
    }

    if (this.isDialog) {
      this.element.on('hidden.bs.modal', () => {
        $("html, body").css("overflow", "auto");
        this.source = "";
      })

      $("a.close", this.element).on("click", () => {
        typeof this.onClose == "function" && this.onClose();
      })
    }

    $("iframe", this.element).on("load", () => {
      this.sectionLoading && this.sectionLoading.hide();
    })

    this.fillData();
  }

  fillData() {
    if (this.title) {
      $(".title", this.element).attr("data-i18n", this.title);
      $(".title", this.element).removeClass("hide");
    } else {
      $(".title", this.element).addClass("hide");
    }

    if (this.description) {
      $(".description", this.element).attr("data-i18n", this.description);
      $(".description", this.element).removeClass("hide");
    } else {
      $(".description", this.element).addClass("hide");
    }

    if (this.source) {
      this.setSource(this.source)
    }
  }

  /**
   * 
   * @param {DIframe} _params 
   */
  updateData(_params = {}) {
    Object.keys(_params).forEach(key => {
      this[key] = _params[key];
    });
    this.fillData();
    this.update();
  }

  setSource(source) {
    this.source = source;
    $("iframe", this.element).attr("src", source)
  }

  show() {
    if (this.isDialog) {
      $("html, body").css("overflow", "hidden");
      $(this.element).modal("show");
    } else {
      this.parent.addClass("show-iframe")
    }
  }

  showStatic() {
    if (this.isDialog) {
      $("html, body").css("overflow", "auto");
      $(this.element).modal({ backdrop: 'static' });
    }
  }

  hide() {
    if (this.isDialog) {
      $(this.element).modal("hide");
    } else {
      this.parent.removeClass("show-iframe")
    }
  }

  isShowDialog() {
    return $(this.element).hasClass("show");
  }
}